export default {
  'hero.badge': 'XR × AI × HCI / 産業DXと民主化',
  'hero.name': '清水啓太郎',
  'hero.nameEn': 'Keitaro Shimizu',
  'hero.title': 'CEO, Play Life Studio  ／  Ph.D Candidate, The University of Tokyo (HCI)',
  'hero.description': '人と社会のためのXR・AI・デジタルツインを、民主化しながら、使われ続ける形で設計する研究者・経営者です。',
  'hero.imageAlt': '清水啓太郎のプロフィール写真',
};
